// Marca Ventanas Hondal — emblema de los tres tejados con ventana (basado en el logo real).
// El logo original del cliente está en /logo.png

export const RoofMark = ({ size = 32, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="12" fill="#0A2540" />
    {/* Tejados */}
    <g fill="#FFFFFF">
      <polygon points="10,42 22,27 34,42" />
      <polygon points="30,42 42,27 54,42" />
      <polygon points="17,43 32,18 47,43" />
      <rect x="8" y="40" width="48" height="4" />
    </g>
    {/* Ventana central */}
    <g>
      <rect x="27" y="30" width="10" height="13" fill="#0066FF" />
      <line x1="32" y1="30" x2="32" y2="43" stroke="#FFFFFF" strokeWidth="1.6" />
      <line x1="27" y1="36.5" x2="37" y2="36.5" stroke="#FFFFFF" strokeWidth="1.6" />
    </g>
  </svg>
);

// Alias para compatibilidad
export const LogoMark = RoofMark;

export const Logo = ({ variant = "dark", size = 32, className = "" }) => {
  const textColor = variant === "light" ? "text-white" : "text-ink";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <RoofMark size={size} />
      <span className={`font-heading font-extrabold tracking-tight leading-none ${textColor}`} style={{ fontSize: size * 0.56 }}>
        Ventanas Hondal
      </span>
    </span>
  );
};

// Marca de agua sutil con el motivo de tejados + ventana para fondos de sección.
export const RoofsWatermark = ({ className = "" }) => (
  <svg viewBox="0 0 200 140" className={className} fill="none" aria-hidden="true" stroke="currentColor" strokeWidth="3" strokeLinejoin="round">
    <polygon points="20,112 58,62 96,112" />
    <polygon points="104,112 142,62 180,112" />
    <polygon points="52,112 100,42 148,112" />
    <line x1="12" y1="112" x2="188" y2="112" />
    <rect x="86" y="80" width="28" height="32" />
    <line x1="100" y1="80" x2="100" y2="112" />
    <line x1="86" y1="96" x2="114" y2="96" />
  </svg>
);

// Alias para compatibilidad con el nombre anterior
export const WindowWatermark = RoofsWatermark;
